import Vue from 'vue';
import store from '../../store';
import batchIngredienceTransformer from '../../transformers/batchIngredience';

const success = ({ data }, resolve) => {
  const batchIngrediences = batchIngredienceTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllMaterials', batchIngrediences);
  resolve(batchIngrediences);
};

const failed = () => {};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/production/batch_ingredience')
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/batchIngredience/all.js